import { render, staticRenderFns } from "./WastenotificationitemsForm.vue?vue&type=template&id=261ff920"
import script from "./WastenotificationitemsForm.vue?vue&type=script&lang=js"
export * from "./WastenotificationitemsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports